export default __webpack_public_path__ + "static/media/leapspin.f978d4d7.gif";